// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import { Collapse, CollapseProps } from 'antd';
import React from 'react';
import { Panel } from './Panel';

import './THCollapse.scss';

type THCollapseProps = CollapseProps;

export const THCollapse = ({ className, ...props }: THCollapseProps) => (
    <Collapse className={classList('th-collapse', className)} {...props} />
);

THCollapse.Panel = Panel;
